import React from 'react';
import SingleCoolFact from './SingleCoolFact';

const CoolFact = () => {
    return (
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
            <div class="fact">
                <div>
                    <span className="before:content-['\e01c'] text-4xl dark:text-[#dedeea] float-left font-[simple-line-icons]"></span>
                    <SingleCoolFact
                        countUpValue="20" 
                        suffix="+" 
                        title="Frontend Project"
                    />
                </div>
            </div>
            <div class="fact">
                <div>
                    {/* <span className="before:content-['\f1d2'] text-4xl dark:text-[#dedeea] float-left font-[bootstrap-icons]"></span> */}
                    <span className="before:content-['\263C'] text-4xl dark:text-[#dedeea] float-left font-[simple-line-icons]"></span>
                    <SingleCoolFact
                        countUpValue="8" 
                        suffix="+" 
                        title="React Project"
                    />
                </div>
            </div>
            <div class="fact">
                <div>
                    {/* <span className="before:content-['\f624'] text-4xl dark:text-[#dedeea] float-left font-[bootstrap-icons]"></span> */}
                    <span className="before:content-['\2756'] text-4xl dark:text-[#dedeea] float-left font-[simple-line-icons]"></span>
                    <SingleCoolFact
                        countUpValue="5" 
                        suffix="+" 
                        title="MERN Stack Project"
                    />
                </div>
            </div>
            <div class="fact">
                <div>
                    <span className="before:content-['\e028'] text-4xl dark:text-[#dedeea] float-left font-[simple-line-icons]"></span>
                    <SingleCoolFact
                        countUpValue="40" 
                        suffix="+" 
                        title="Total Project"
                    />
                </div>
            </div>
        </div>
    );
};

export default CoolFact;